module.exports = __webpack_public_path__ + "img/md-radio-button-off.4b712f4f.svg";